// extracted by mini-css-extract-plugin
export default {"red":"contactForm_red__Oxb+B","input-text":"contactForm_input-text__eGS3U","form":"contactForm_form__c9LIM","messageBanner":"contactForm_messageBanner__kjJEj"};